import clsx from 'clsx'
import { useMemo } from 'react'
import React from 'react'
import { FieldErrors } from 'react-hook-form'
import { FormattedMessage } from 'react-intl'

import s from './styles.module.scss'

import AdultsPicker from './adults-picker/AdultsPicker'
import DatesPicker, { DatesPickerProps } from './dates-picker/DatesPicker'
import { ISelectProposalForm } from '../../modal-select-proposal.types'
import { TravelTypeEnum } from '../../../../../lib/graphql'
import { useTravelTypeContext } from '../../../../contexts'

interface IDatesAdultsPickerProps extends DatesPickerProps {
  errors: FieldErrors<ISelectProposalForm>
}

export const DatesAdultsPicker = ({
  control,
  house,
  dates,
  errors,
  ...remainingPickerProps
}: IDatesAdultsPickerProps) => {
  const hasErrors = useMemo(() => {
    return Boolean(errors.dates?.message || errors.adults?.message)
  }, [errors.dates, errors.adults])
  const { travelType } = useTravelTypeContext()

  const title =
    travelType === TravelTypeEnum.CORPORATE_EVENING_EVENT ? (
      <FormattedMessage
        id='ui.DatesAdultsPicker.yourDate'
        defaultMessage='Votre date'
      />
    ) : (
      <FormattedMessage
        id='ui.DatesAdultsPicker.yourDates'
        defaultMessage='Vos dates'
      />
    )
  return (
    <div className={s.container}>
      <h5>{title}</h5>
      <div
        className={clsx(s.datesContainer, { [s.containerError]: hasErrors })}
      >
        <DatesPicker
          control={control}
          house={house}
          dates={dates}
          {...remainingPickerProps}
        />
        <span className={s.spacer} />
        <AdultsPicker control={control} house={house} />
        {hasErrors && (
          <p className={s.form__error}>
            {errors.dates?.message || errors.adults?.message}
          </p>
        )}
      </div>
    </div>
  )
}
